import { sbEditable } from '@storyblok/storyblok-editable';
import classNames from 'classnames';

import DynamicComponent from 'components/DynamicComponent';
import type { ReactElement, RefObject } from 'react';
import { useRef } from 'react';
import type { PageProps } from './Page.data';
import styles from './Page.module.scss';

export default function Page({ className, canTransitionIn, blok, ref }: PageProps): ReactElement {
  const localRef = useRef(null);
  const elementRef = (ref || localRef) as RefObject<HTMLDivElement | null>;

  return (
    <main
      ref={elementRef}
      className={classNames(styles.page, className)}
      id="main-content"
      {...sbEditable(blok)}
      key={blok._uid}
    >
      {blok?.modules?.map((item) => (
        <DynamicComponent blok={item} key={item._uid} canTransitionIn={canTransitionIn} />
      ))}
    </main>
  );
}
